import { determinePaymentVersion } from './paymentVersion';
import {
  analyticsEventsTracker,
  EVENT_TRACKERS,
  GTMOnboardingFunnelEvent,
} from "../analytics";

export function trackBlockScrollDepth(target, blockName) {
  if (typeof window === 'undefined' || !window.dataLayer) {
    console.warn('[ScrollTracker] dataLayer not found');
    return;
  }

  var el = null;
  if (target instanceof Element) {
    el = target;
  } else if (typeof target === 'string') {
    var selector = target.startsWith('.') || target.startsWith('#') ? target : '.' + target;
    el = document.querySelector(selector);
  }
  if (!el) {
    console.error('[ScrollTracker] Element not found:', target);
    return;
  }

  var lastIdx = null;
  var ticking = false;

  var container = (el.scrollHeight > el.clientHeight) ? el : window;

  function update() {
    var percent = 0;
    if (container === window) {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var elTop = el.offsetTop;
      var elHeight = el.offsetHeight;
      var scrolled = scrollY + vh - elTop;
      percent = (elHeight > 0) ? Math.round((scrolled / elHeight) * 1000) / 10 : 0;
    } else {
      var scrollTop = el.scrollTop;
      var scrollHeight = el.scrollHeight;
      var clientHeight = el.clientHeight;
      percent = Math.round(((scrollTop + clientHeight) / scrollHeight) * 1000) / 10;
    }
    percent = Math.max(0, Math.min(100, percent));

    var idx = Math.min(9, Math.floor(percent / 10));
    var bucket = (idx * 10) + '-' + ((idx + 1) * 10);

    if (lastIdx !== null && idx > lastIdx) {
      analyticsEventsTracker.trackWithTarget(
        GTMOnboardingFunnelEvent.blockScroll(blockName, percent, bucket, determinePaymentVersion()),
        EVENT_TRACKERS.GTM
      );
      window.dataLayer.push({
        event: 'block_scroll_depth',
        block_name: blockName,
        scroll_percent: percent,
        scroll_bucket: bucket,
        payment_type: determinePaymentVersion()
      });
    }

    lastIdx = (lastIdx === null) ? idx : Math.max(lastIdx, idx);
    ticking = false;
  }

  function handleScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function waitForElement() {
    if (el) {
      container.addEventListener('scroll', handleScroll, { passive: true });
      update();
    } else {
      setTimeout(waitForElement, 200);
    }
  }

  waitForElement();
}
